<div class="carousel-container">
  <carousel [interval]="myInterval" [showIndicators]="false" [isAnimated]="false" [noPause]="true"
    [(activeSlide)]="currentSlideIndex" (activeSlideChange)="onSlideChange($event)">
    @for (item of getBannerList() ; track item; let i = $index) {
      <slide>
        @if (getBannerList(); as banners) {
          <div class="carousel-container">
            <div class="banner-count">
              <!-- Total Banners: {{ banners.length }} -->
            </div>
          </div>
        }
        <div class="bannercontainer">
          <!--  Link Old Featues Exiting-->
          @if (item.link) {
            @if (item.isExternalLink) {
              <a [href]="item.link" target="_blank" title="{{item.widget_name}}" class="banner-link">
                <img [src]="item.bannerUrl" [alt]="item.widget_name" class="banner-image">
              </a>
            }
            @if (!item.isExternalLink) {
              <a style="cursor: pointer;" (click)="goto(item.link)" class="banner-link {{item.link}}" title="{{item.widget_name}}">
                <img [src]="item.bannerUrl" [alt]="item.widget_name" class="banner-image">
              </a>
            }
          }
          <!-- Mobile Banner Link -->
          @if (item.banner_link) {
            <a  style="cursor: pointer;" (click)="goto(item.banner_link)" class="banner-link {{item.banner_link}}" title="{{item.widget_name}}">
              <img [src]="item.bannerUrl" [alt]="item.widget_name" class="banner-image">
            </a>
          }
          <!-- Image without Mobile bannerlink and link -->
          @if (!item.banner_link && !item.link) {
            <img [src]="item.bannerUrl" [alt]="item.widget_name" title="{{item.widget_name}}" class="banner-image">
          }
        </div>
      </slide>
    }

  </carousel>



  <!-- <div class="bannercontainer" *ngIf="config.data && config.data.bannerUrl != undefined">
  <ng-container *ngIf="config.data.link">
    <a title="{{config.data.widget_name}}" href="{{config.data.link}}" *ngIf="config.data.isExternalLink" target="_blank" ><img [attr.src]="config.data.bannerUrl" /></a>
    <a style="cursor: pointer;" (click)="goto(config.data.link)" class="{{config.data.link}}" title="{{config.data.widget_name}}"  *ngIf="!config.data.isExternalLink" >
    <img [attr.src]="config.data.bannerUrl" /></a>
  </ng-container>
  <ng-container  *ngIf="!config.data.link">
    <img title="{{config.data.widget_name}}" [attr.src]="config.data.bannerUrl" />
  </ng-container>
</div> -->

</div>



